import React from 'react';
import { Search, Filter, X } from 'lucide-react';

const EvenementFilters = ({ filters, onFilterChange, onReset, activeFiltersCount }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter size={20} className="text-[#FF6B00]" />
          <h3 className="font-semibold text-gray-900">Filtres</h3>
          {activeFiltersCount > 0 && (
            <span className="px-2 py-1 bg-[#FF6B00] text-white text-xs rounded-full">
              {activeFiltersCount}
            </span>
          )}
        </div>
        {activeFiltersCount > 0 && (
          <button
            onClick={onReset}
            className="text-sm text-gray-600 hover:text-[#FF6B00] flex items-center gap-1 transition-colors"
          >
            <X size={16} />
            Réinitialiser
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
        {/* Recherche */}
        <div className="relative">
          <Search size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Période */}
        <select
          value={filters.periode}
          onChange={(e) => onFilterChange('periode', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="">Toutes les périodes</option>
          <option value="upcoming">À venir</option>
          <option value="today">Aujourd'hui</option>
          <option value="past">Passés</option>
        </select>

        {/* Auteur */}
        <input
          type="text"
          placeholder="Auteur..."
          value={filters.auteur}
          onChange={(e) => onFilterChange('auteur', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        />

        {/* Tri */}
        <select
          value={filters.ordering}
          onChange={(e) => onFilterChange('ordering', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="-date_creation">Plus récents</option>
          <option value="date_creation">Plus anciens</option>
          <option value="date">Date événement (croissant)</option>
          <option value="-date">Date événement (décroissant)</option>
          <option value="titre">Titre (A-Z)</option>
          <option value="-titre">Titre (Z-A)</option>
        </select>
      </div>
    </div>
  );
};

export default EvenementFilters;
